module.exports = __webpack_public_path__ + "img/img_throw_2@3x_v2.0ff08ff6.png";